import React from 'react';
import { Warning, ArrowSquareOut, CheckCircle } from '@phosphor-icons/react';

export const Auth0ScopeError = ({ error, onRetry }) => {
    const isScopeError = error && error.includes('insufficient_scope');
    
    if (!isScopeError) {
        return null;
    }

    return (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <div className="flex items-start">
                <Warning size={24} className="text-yellow-600 mt-1 mr-3 flex-shrink-0" />
                <div className="flex-1">
                    <h3 className="text-lg font-medium text-yellow-800 mb-2">
                        Auth0 Configuration Required
                    </h3>
                    <p className="text-yellow-700 mb-4">
                        Your Auth0 application needs to be configured to access the Management API.
                    </p>
                    
                    <div className="bg-white rounded-md p-4 mb-4">
                        <h4 className="font-medium text-gray-900 mb-2">Required Steps:</h4>
                        <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700">
                            <li>Go to your Auth0 Dashboard</li>
                            <li>Navigate to <strong>Applications</strong> → Your Application</li>
                            <li>Go to the <strong>APIs</strong> tab</li>
                            <li>Click <strong>"Add API"</strong></li>
                            <li>Search for <strong>"Auth0 Management API"</strong> and select it</li>
                            <li>Grant the following scopes:</li>
                        </ol>
                        
                        <div className="mt-3 space-y-1">
                            <div className="flex items-center text-sm">
                                <CheckCircle size={16} className="text-green-500 mr-2" />
                                <code className="bg-gray-100 px-2 py-1 rounded">read:users</code>
                            </div>
                            <div className="flex items-center text-sm">
                                <CheckCircle size={16} className="text-green-500 mr-2" />
                                <code className="bg-gray-100 px-2 py-1 rounded">read:current_user</code>
                            </div>
                            <div className="flex items-center text-sm">
                                <CheckCircle size={16} className="text-green-500 mr-2" />
                                <code className="bg-gray-100 px-2 py-1 rounded">read:user_idp_tokens</code>
                            </div>
                        </div>
                    </div>
                    
                    <div className="flex flex-col sm:flex-row gap-3">
                        <a
                            href="https://manage.auth0.com/dashboard"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors"
                        >
                            <ArrowSquareOut size={16} className="mr-2" />
                            Open Auth0 Dashboard
                        </a>
                        
                        {onRetry && (
                            <button
                                onClick={onRetry}
                                className="inline-flex items-center px-4 py-2 bg-gray-600 text-white text-sm font-medium rounded-md hover:bg-gray-700 transition-colors"
                            >
                                Retry After Configuration
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}; 